import { RuleProps } from 'types/application';

export const LICENCE_CATEGORY = 'licence-category';
export const LICENCE_VALIDITY_PERIOD = 'licence-validity-period';
export const OTHER_DETAILS = 'other-details';
export const FOREIGN_COMPANY_DETAILS = 'foreign-company-details';
export const OPERATING_LOCATION = 'operating-location-details';
export const EXHIBITION_INFORMATION = 'exhibition-information';
export const EXHIBITION_ADDRESS = 'exhibition-address';
export const EXHIBITION_PERIOD = 'exhibition-period';
export const TYPE_OF_EXHIBITION = 'type-of-exhibition';
export const TYPE_OF_EQUIPMENT = 'type-of-equipment';
export const STATION = 'station';
export const BASED_LAND_FIXED_STATION_INFORMATION = 'based-land-fixed-station-information';
export const RADIO_EQUIPMENT_INFORMATION = 'radio-equipment-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_EXBF_LICENCE = [
    {
            sectionID: LICENCE_CATEGORY,
            sectionName: '',
            fieldList: [
                {
                    id: 'amend-table',
                    label: ' ',
                    type: 'table',
                    subFields: [
                        {
                            id: 'type',
                            header: 'I want to amend',
                            type: 'text'
                        }
                    ],
                    span: 12
                },
                {
                    id: 'licence-category',
                    label: 'Licence Category',
                    type: 'text',
                    span: 12
                }
            ]
        },
        {
            sectionID: OTHER_DETAILS,
            sectionName: 'Other Details',
            fieldList: [
                {
                    id: 'proposed-used-of-system',
                    label: 'Proposed use of System/Equipment',
                    type: 'text'
                },
                {
                    id: 'remarks',
                    label: 'Remarks',
                    type: 'text'
                }
            ]
        },
        {
            sectionID: FOREIGN_COMPANY_DETAILS,
            sectionName: 'Foreign Company Details',
            fieldList: [
                {
                    id: 'foreign-company-name',
                    label: 'Foreign Company Name (Optional)',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'address-line-one',
                    label: 'Address Line 1 (Optional)',
                    type: 'text'
                },
                {
                    id: 'address-line-two',
                    label: 'Address Line 2 (Optional)',
                    type: 'text'
                },
                {
                    id: 'address-line-three',
                    label: 'Address Line 3 (Optional)',
                    type: 'text'
                },
                {
                    id: 'address-line-four',
                    label: 'Address Line 4 (Optional)',
                    type: 'text'
                },
                {
                    id: 'address-line-five',
                    label: 'Address Line 5 (Optional)',
                    type: 'text'
                },
                {
                    id: 'contact-number',
                    label: 'Contact Number (Optional)',
                    type: 'text'
                },
                {
                    id: 'email',
                    label: 'Email (Optional)',
                    type: 'text'
                },
                {
                    id: 'city',
                    label: 'City (Optional)',
                    type: 'text'
                },
                {
                    id: 'state',
                    label: 'State (Optional)',
                    type: 'text'
                },
                {
                    id: 'zip-code',
                    label: 'Zip Code (Optional)',
                    type: 'text'
                },
                {
                    id: 'country',
                    label: 'Country (Optional)',
                    type: 'text'
                }
            ]
        },
        {
            sectionID: OPERATING_LOCATION,
            sectionName: 'Operating Location',
            fieldList: [
                {
                    id: 'operating-location-details',
                    label: '',
                    type: 'table2',
                    span: 12,
                    subFields: [
                        {
                            id: 'no',
                            header: 'No.',
                            type: 'text'
                        },
                        {
                            id: 'building-name',
                            header: 'Building Name',
                            type: 'text'
                        },
                        {
                            id: 'street-name',
                            header: 'Street Name',
                            type: 'text'
                        },
                        {
                            id: 'block-house-no',
                            header: 'Block/House No.',
                            type: 'text'
                        },
                        {
                            id: 'floor-level',
                            header: 'Floor/Level',
                            type: 'text'
                        },
                        {
                            id: 'unit',
                            header: 'Unit',
                            type: 'text'
                        },
                        {
                            id: 'postal-code',
                            header: 'Postal Code',
                            type: 'text'
                        }
                    ]
                }
            ]
        },
        {
            sectionID: EXHIBITION_INFORMATION,
            sectionName: 'Exhibition Information',
            fieldList: [
                {
                    id: 'organizer-name',
                    label: 'Organizer Name',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'organizer-contact-person',
                    label: 'Organizer Contact Person',
                    type: 'text'
                },
                {
                    id: 'designation',
                    label: 'Designation',
                    type: 'text'
                },
                {
                    id: 'tel-no',
                    label: 'Tel No',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'mobile-no',
                    label: 'Mobile Number (Optional)',
                    type: 'text'
                },
                {
                    id: 'fax-no',
                    label: 'Fax Number (Optional)',
                    type: 'text'
                },
                {
                    id: 'email',
                    label: 'Email',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'exhibition-name',
                    label: 'Exhibition Name',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'exhibition-booth-no',
                    label: 'Exhibition Booth No',
                    type: 'text',
                    span: 12
                }
            ]
        },
        {
            sectionID: EXHIBITION_PERIOD,
            sectionName: 'Exhibition Period',
            fieldList: [
                {
                    id: 'start-date',
                    label: 'Start Date',
                    type: 'text'
                },
                {
                    id: 'end-date',
                    label: 'End Date',
                    type: 'text'
                }
            ]
        },
        {
            sectionID: EXHIBITION_ADDRESS,
            sectionName: 'Exhibition Address',
            fieldList: [
                {
                    id: 'address-type',
                    label: 'Address Type',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'address-line-one',
                    label: 'Address Line 1',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-address-line-one`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] === 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'address-line-two',
                    label: 'Address Line 2',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-address-line-two`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] === 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'address-line-three',
                    label: 'Address Line 3',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-address-line-three`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] === 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'postal-code',
                    label: 'Postal Code',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-postal-code`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'building-name',
                    label: 'Building Name',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-building-name`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'block-house-no',
                    label: 'Block/House No.',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-block-house-no`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'street-name',
                    label: 'Street Name',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-street-name`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'floor-level-optional',
                    label: 'Floor/Level (Optional)',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-floor-level-optional`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                },
                {
                    id: 'unit-optional',
                    label: 'Unit (Optional)',
                    type: 'text',
                    rule: {
                        baseIds: [`${EXHIBITION_ADDRESS}-unit-optional`],
                        hidden: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${EXHIBITION_ADDRESS}-address-type`] !== 'Singapore');
                            return result;
                        }
                    }
                }
            ]
        },
        {
            sectionID: TYPE_OF_EQUIPMENT,
            sectionName: 'Type Of Equipment',
            fieldList: [
                {
                    id: 'equipment-type',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'indicate-equipment',
                    label: 'indicate the type of equipment, model, and whether it has been registered with IMDA. Provide the technical specifications if the equipment is non-registered equipment. (Optional)',
                    type: 'text',
                    span: 12
                }
            ]
        },
        {
            sectionID: STATION,
            sectionName: 'Station / Equiment Information',
            fieldList: [
                {
                    id: 'station-name',
                    label: 'Station Name',
                    type: 'select'
                },
                {
                    id: 'total-number-of-stations',
                    label: 'Total Number of Station(s)',
                    type: 'text'
                }
            ]
        },
        {
            sectionID: BASED_LAND_FIXED_STATION_INFORMATION,
            sectionName: '',
            fieldList: [
                {
                    id: 'station-or-equipment-name',
                    label: 'Station/Equipment Name',
                    type: 'text',
                    span: 12
                },
                {
                    id: 'purpose-and-objectives',
                    label: 'Purpose And Objectives',
                    type: 'text',
                    span: 12
                }
            ]
        },
        {
            sectionID: RADIO_EQUIPMENT_INFORMATION,
            sectionName: '',
            fieldList: [
                {
                    id: 'brand-and-model-transmitter',
                    label: 'Brand and Model (Transmitter)',
                    type: 'text'
                },
                {
                    id: 'brand-and-model-receiver',
                    label: 'Brand and Model (Receiver)',
                    type: 'text'
                },
                {
                    id: 'serial-no-transmitter',
                    label: 'Serial No. (Transmitter)',
                    type: 'text'
                },
                {
                    id: 'serial-no-receiver',
                    label: 'Serial No. (Receiver)',
                    type: 'text'
                },
                {
                    id: 'rf-output-power-transmitter',
                    label: 'RF Output Power (Transmitter)',
                    type: 'text'
                },
                {
                    id: 'rf-output-power-receiver',
                    label: 'RF Output Power (Receiver)',
                    type: 'text'
                }
            ]
        },
        {
            sectionID: SUPPORTING_DOCUMENTS,
            sectionName: 'Supporting Documents',
            fieldList: [
                {
                    id: 'supporting-documents',
                    label: ' ',
                    type: 'file',
                    span: 12
                }
            ]
        }
];
